﻿[
  {
    "draftJersey": 101,
    "name": "Andrea Uceda",
    "age": 20,
    "foot": "right",
    "height": 168,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823-ql/101.jpg",
    "macros": {
      "reflexes": 66,
      "handling": 81,
      "kicking": 70,
      "diving": 75,
      "average": 73
    },
    "profileYtVideoId": "9bwjT6O0XBo",
    "matchYtVideoId": "8PTQPlZDOYM"
  },
  {
    "draftJersey": 102,
    "name": "Clara Sabadell",
    "age": 21,
    "foot": "right",
    "height": 165,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823-ql/102.jpg",
    "macros": {
      "reflexes": 44,
      "handling": 42,
      "kicking": 50,
      "diving": 46,
      "average": 46
    },
    "profileYtVideoId": "zFgfaPowtRU",
    "matchYtVideoId": "8PTQPlZDOYM"
  },
  {
    "draftJersey": 103,
    "name": "Judit March",
    "age": 28,
    "foot": "left",
    "height": 172,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823-ql/103.jpg",
    "macros": {
      "reflexes": 82,
      "handling": 75,
      "kicking": 69,
      "diving": 72,
      "average": 75
    },
    "profileYtVideoId": "UJUoeIH9hw8",
    "matchYtVideoId": "7YrXTAnvOn0"
  },
  {
    "draftJersey": 104,
    "name": "Laura Sánchez",
    "age": 24,
    "foot": "right",
    "height": 165,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823-ql/104.jpg",
    "macros": {
      "reflexes": 50,
      "handling": 50,
      "kicking": 45,
      "diving": 52,
      "average": 49
    },
    "profileYtVideoId": "zPWBKUaVpAY",
    "matchYtVideoId": "7YrXTAnvOn0"
  },
  {
    "draftJersey": 105,
    "name": "Nerea Albarracin",
    "age": 20,
    "foot": "right",
    "height": 160,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823-ql/105.jpg",
    "macros": {
      "reflexes": 77,
      "handling": 57,
      "kicking": 50,
      "diving": 60,
      "average": 61
    },
    "profileYtVideoId": "UEFEylrx7hk",
    "matchYtVideoId": "8PTQPlZDOYM"
  },
  {
    "draftJersey": 107,
    "name": "Paula Mengual",
    "age": 20,
    "foot": "right",
    "height": 173,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823-ql/107.jpg",
    "macros": {
      "reflexes": 61,
      "handling": 72,
      "kicking": 68,
      "diving": 72,
      "average": 68
    },
    "profileYtVideoId": "8jtWm6TceDA",
    "matchYtVideoId": "qsZ2BIM5CBA"
  },
  {
    "draftJersey": 109,
    "name": "Abril Cura",
    "age": 18,
    "foot": "right",
    "height": 162,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823-ql/109.jpg",
    "macros": {
      "reflexes": 83,
      "handling": 84,
      "kicking": 65,
      "diving": 81,
      "average": 78
    },
    "profileYtVideoId": "GPXkKI3F0is",
    "matchYtVideoId": "qsZ2BIM5CBA"
  },
  {
    "draftJersey": 110,
    "name": "Noemí Salido",
    "age": 23,
    "foot": "right",
    "height": 160,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823-ql/110.jpg",
    "macros": {
      "reflexes": 61,
      "handling": 52,
      "kicking": 50,
      "diving": 60,
      "average": 56
    },
    "profileYtVideoId": "h0WwPFRyoto",
    "matchYtVideoId": "LPU3e3etB5I"
  },
  {
    "draftJersey": 112,
    "name": "Naima Reixach",
    "age": 24,
    "foot": "right",
    "height": 167,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823-ql/112.jpg",
    "macros": {
      "reflexes": 42,
      "handling": 41,
      "kicking": 44,
      "diving": 42,
      "average": 42
    },
    "profileYtVideoId": "OmN8xtskQy4",
    "matchYtVideoId": "8PTQPlZDOYM"
  },
  {
    "draftJersey": 119,
    "name": "Isabel Asensio",
    "age": 18,
    "foot": "right",
    "height": 161,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823-ql/119.jpg",
    "macros": {
      "reflexes": 68,
      "handling": 68,
      "kicking": 68,
      "diving": 70,
      "average": 69
    },
    "profileYtVideoId": "6ph9MdcAy9s",
    "matchYtVideoId": "qsZ2BIM5CBA"
  },
  {
    "draftJersey": 120,
    "name": "Rocio Ruiz",
    "age": 20,
    "foot": "right",
    "height": 163,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823-ql/120.jpg",
    "macros": {
      "reflexes": 72,
      "handling": 46,
      "kicking": 70,
      "diving": 63,
      "average": 63
    },
    "profileYtVideoId": "nqbUm-Sp9AA",
    "matchYtVideoId": "LPU3e3etB5I"
  }
]
